export default "__VITE_ASSET__5UWbIY7N__"